import { Typography, Tabs, Tab } from '@mui/material'
import { useEffect, useState } from 'react'
import { TabDisplay } from '../../Components/TabDisplay'
import { IncomeApprovalList, IncomeApprovalType } from './IncomeApprovalList'
import { sendGet } from '../../hooks/use-fetch'

enum IncomeApprovalTabs {
  OverIncome = 'OverIncome',
  PriorityWaivers = 'PriorityWaivers',
  Both = 'Both',
  Neither = 'Neither'
}

export function IncomeApprovalTabList (): JSX.Element {
  const [currentTab, setCurrentTab] = useState(0)
  const [tabsAvailable, setTabsAvailable] = useState(IncomeApprovalTabs.Neither)
  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const { response, error } = await sendGet('/IncomeApproval/IncomeApprovalTabsAvailable', {})
      if (error[0] === '') {
        setTabsAvailable(response)
        if (response === IncomeApprovalTabs.PriorityWaivers) {
          setCurrentTab(1)
        }
      }
    }
    void loadData()
  }, [])

  return <>
    <Typography variant='h3' data-testid="page-header">Income Approvals</Typography>
    <Tabs value={currentTab}
      data-testid='tabs'
      onChange={(e, val) => { setCurrentTab(val) }}
      aria-label="Income Approval Tabs"
    >
      {(tabsAvailable === IncomeApprovalTabs.OverIncome || tabsAvailable === IncomeApprovalTabs.Both) && <Tab label="Over Income" value={0} data-testid="overIncome" />}
      {(tabsAvailable === IncomeApprovalTabs.PriorityWaivers || tabsAvailable === IncomeApprovalTabs.Both) && <Tab label="Priority Waivers" value={1} data-testid="priorityWaivers" />}
    </Tabs>
    {(tabsAvailable === IncomeApprovalTabs.OverIncome || tabsAvailable === IncomeApprovalTabs.Both) && <TabDisplay
      index={0}
      value={currentTab}
    >
      <IncomeApprovalList type={IncomeApprovalType.OverIncome} />
    </TabDisplay >
    }
    {(tabsAvailable === IncomeApprovalTabs.PriorityWaivers || tabsAvailable === IncomeApprovalTabs.Both) && <TabDisplay
      index={1}
      value={currentTab}
    >
      <IncomeApprovalList type={IncomeApprovalType.PriorityWaivers} />
    </TabDisplay>
    }
  </>
}
